import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const useReCAPTCHARef = () => useRef<ReCAPTCHA>(null);

export default useReCAPTCHARef;
